import React, { useState, useEffect } from "react";
import CryptoJS from "crypto-js";
import api from "../api";              // <-- trocado para api.js
import "./estilodash.css";

const AdicionaLicencas = () => {
  const [apiKey] = useState("abc1234"); // mantido só se precisar no futuro

  const [clientes, setClientes] = useState([]);
  const [planos, setPlanos] = useState([]);
  const [licencas, setLicencas] = useState([]);

  const [clienteId, setClienteId] = useState("");
  const [conta, setConta] = useState("");
  const [chave, setChave] = useState("");
  const [tipo, setTipo] = useState("Real"); // Real | Demo
  const [status, setStatus] = useState("1"); // "1" ativa, "0" inativa
  const [dataExpiracao, setDataExpiracao] = useState("");

  const [carregando, setCarregando] = useState(false);
  const [msg, setMsg] = useState("");

  // getAuthHeaders não é mais necessário, o api.js já injeta o Authorization
  // via interceptor, então removemos para simplificar.

  useEffect(() => {
    carregarDadosIniciais();
  }, []);

  const carregarDadosIniciais = async () => {
    try {
      setCarregando(true);
      setMsg("");

      const [respCli, respLic, respPlanos] = await Promise.all([
        api.get("/api/clientes"),
        api.get("/api/licencas"),
        api.get("/api/planos-ativos"),
      ]);

      setClientes(respCli.data || []);
      setLicencas(respLic.data || []);
      setPlanos(respPlanos.data || []);
    } catch (err) {
      console.error("Erro ao carregar dados (clientes/licenças/planos):", err);
      setMsg("Erro ao carregar dados. Verifique login/servidor.");
    } finally {
      setCarregando(false);
    }
  };

  // ===================== HELPERS =====================

  const getCliente = (id) =>
    clientes.find((c) => Number(c.id) === Number(id));

  const getPlano = (id) =>
    planos.find((p) => Number(p.id) === Number(id));

  const licencasDoCliente = clienteId
    ? licencas.filter((l) => Number(l.id_cliente) === Number(clienteId))
    : [];

  const totalReaisAtivas = licencasDoCliente.filter(
    (l) =>
      String(l.status) === "1" && (l.tipo || "").toLowerCase() === "real"
  ).length;

  const totalDemoAtivas = licencasDoCliente.filter(
    (l) =>
      String(l.status) === "1" && (l.tipo || "").toLowerCase() === "demo"
  ).length;

  const clienteSelecionado = clienteId ? getCliente(clienteId) : null;
  const planoCliente = clienteSelecionado
    ? getPlano(clienteSelecionado.plano_id)
    : null;

  const formatDate = (dateString) => {
    if (!dateString) return "—";
    const d = new Date(dateString);
    if (Number.isNaN(d.getTime())) return dateString;
    return d.toISOString().slice(0, 10);
  };

  // ===================== GERAÇÃO DE CHAVE (CÁLCULO ORIGINAL) =====================

  const handleGerarChave = () => {
    if (!conta) {
      alert("Informe o número da conta antes de gerar a chave.");
      return;
    }

    const numeroConta = parseInt(conta, 10);

    if (Number.isNaN(numeroConta)) {
      alert("Número da conta inválido. Use apenas números.");
      return;
    }

    const resultado = numeroConta * 11 - 181818;
    const resultadoString = resultado.toString();

    console.log("Entrada para MD5:", resultadoString);
    const hash = CryptoJS.MD5(resultadoString).toString(CryptoJS.enc.Hex);
    console.log("Hash gerado:", hash);

    setChave(hash);
  };

  // ===================== SALVAR LICENÇA =====================

  const resetFormFields = () => {
    setConta("");
    setChave("");
    setTipo("Real");
    setStatus("1");
    setDataExpiracao("");
  };

  const handleSalvarLicenca = async (e) => {
    e.preventDefault();

    if (!clienteId) {
      alert("Selecione um cliente.");
      return;
    }
    if (!conta) {
      alert("Informe a conta (login MT5).");
      return;
    }
    if (!chave) {
      alert("Gere a chave ou cole a lkey gerada pelo seu processo atual.");
      return;
    }

    const licencaExistente = licencas.find((licenca) => licenca.conta === conta);
    if (licencaExistente) {
      alert("Erro: Licença para esta conta já existe.");
      return;
    }

    try {
      setCarregando(true);
      setMsg("");

      const body = {
        clienteId: clienteId,
        conta,
        lkey: chave,
        status, // "0" ou "1" (o backend normaliza para string)
        date_exp: dataExpiracao || null,
        tipo,
      };

      await api.post("/api/licencas", body);

      setMsg("Licença criada com sucesso!");
      resetFormFields();

      const respLic = await api.get("/api/licencas");
      setLicencas(respLic.data || []);
    } catch (err) {
      console.error("Erro ao salvar licença:", err);
      alert("Erro ao salvar licença.");
    } finally {
      setCarregando(false);
    }
  };

  // ===================== RENDER =====================

  return (
    <div className="pagamentos-container">
      <h3>Adicionar Licenças</h3>

      <div className="barra-acoes-pagamento">
        <button type="button" onClick={carregarDadosIniciais}>
          Recarregar dados
        </button>
      </div>

      {msg && <p style={{ color: "green", marginTop: 8 }}>{msg}</p>}
      {carregando && <p>Processando...</p>}

      {/* SELEÇÃO DE CLIENTE */}
      <div className="form-linha">
        <label style={{ flex: 1 }}>
          Cliente:
          <select
            value={clienteId}
            onChange={(e) => setClienteId(e.target.value)}
          >
            <option value="">Selecione...</option>
            {clientes.map((c) => (
              <option key={c.id} value={c.id}>
                {c.nome} ({c.email})
              </option>
            ))}
          </select>
        </label>
      </div>

      {/* RESUMO DO CLIENTE E LICENÇAS */}
      {clienteSelecionado && (
        <div className="card-resumo-cliente">
          <h4>{clienteSelecionado.nome}</h4>
          <div className="texto-menor">{clienteSelecionado.email}</div>
          {clienteSelecionado.phone && (
            <div className="texto-menor">Tel: {clienteSelecionado.phone}</div>
          )}
          {clienteSelecionado.cpf && (
            <div className="texto-menor">CPF: {clienteSelecionado.cpf}</div>
          )}

          <div style={{ marginTop: 6 }}>
            <strong>Plano: </strong>
            {planoCliente ? planoCliente.nome : "—"}
            {planoCliente && (
              <span className="texto-menor">
                {" "}
                | Slots incluídos: {planoCliente.slots_inclusos}
              </span>
            )}
          </div>

          <div>
            <strong>Slots contratados: </strong>
            {clienteSelecionado.slots_contratados}
          </div>

          <div>
            <strong>Status cliente: </strong>
            <span
              className={
                String(clienteSelecionado.status) === "1"
                  ? "badge badge-ativo"
                  : "badge badge-inativo"
              }
            >
              {String(clienteSelecionado.status) === "1" ? "Ativo" : "Inativo"}
            </span>
          </div>

          <div>
            <strong>Isento: </strong>
            <span
              className={
                String(clienteSelecionado.isento) === "1"
                  ? "badge badge-isento"
                  : "badge badge-normal"
              }
            >
              {String(clienteSelecionado.isento) === "1"
                ? "Sim (Isento)"
                : "Não"}
            </span>
          </div>

          <div style={{ marginTop: 10 }}>
            <strong>Licenças do cliente:</strong>
            <div className="texto-menor">
              Total: {licencasDoCliente.length} | Reais ativas:{" "}
              {totalReaisAtivas} | Demo ativas: {totalDemoAtivas}
            </div>
            {clienteSelecionado.slots_contratados &&
              totalReaisAtivas >
                Number(clienteSelecionado.slots_contratados) && (
                <div
                  className="texto-menor"
                  style={{ color: "#ff6666", marginTop: 4 }}
                >
                  ⚠ Já existem mais licenças Reais ativas ({totalReaisAtivas})
                  do que slots contratados (
                  {clienteSelecionado.slots_contratados}).
                </div>
              )}
          </div>
        </div>
      )}

      {/* FORMULÁRIO DE NOVA LICENÇA */}
      <form className="form-pagamento" onSubmit={handleSalvarLicenca}>
        <div className="form-linha">
          <label style={{ flex: 2 }}>
            Conta (login MT5):
            <input
              type="text"
              value={conta}
              onChange={(e) => setConta(e.target.value)}
              placeholder="Ex: 12345678"
            />
          </label>

          <label style={{ flex: 1 }}>
            Tipo:
            <select value={tipo} onChange={(e) => setTipo(e.target.value)}>
              <option value="Real">Real</option>
              <option value="Demo">Demo</option>
            </select>
          </label>

          <label style={{ flex: 1 }}>
            Status:
            <select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="1">Ativa</option>
              <option value="0">Inativa</option>
            </select>
          </label>
        </div>

        <div className="form-linha">
          <label style={{ flex: 1 }}>
            Data de expiração:
            <input
              type="date"
              value={dataExpiracao}
              onChange={(e) => setDataExpiracao(e.target.value)}
            />
          </label>
        </div>

        <div className="form-linha">
          <label style={{ flex: 1 }}>
            Chave (lkey):
            <input
              type="text"
              value={chave}
              onChange={(e) => setChave(e.target.value)}
              placeholder="Gerada pelo botão"
            />
          </label>
        </div>

        <div className="form-linha" style={{ marginBottom: 10 }}>
          <button type="button" onClick={handleGerarChave}>
            Gerar chave
          </button>
          <button
            type="button"
            style={{ marginLeft: 8 }}
            onClick={resetFormFields}
          >
            Limpar campos da licença
          </button>
          <button type="submit">Salvar licença</button>
        </div>
      </form>

      {/* LISTA RÁPIDA DE LICENÇAS DO CLIENTE */}
      {clienteSelecionado && (
        <>
          <h4 style={{ marginTop: 20 }}>Licenças existentes do cliente</h4>
          <table className="tabela-pagamentos">
            <thead>
              <tr>
                <th>Conta</th>
                <th>Tipo</th>
                <th>Status</th>
                <th>Expiração</th>
                <th>Chave (lkey)</th>
              </tr>
            </thead>
            <tbody>
              {licencasDoCliente.map((l) => (
                <tr key={l.id}>
                  <td>{l.conta}</td>
                  <td>{l.tipo || "—"}</td>
                  <td>{String(l.status) === "1" ? "Ativa" : "Inativa"}</td>
                  <td>{formatDate(l.date_exp)}</td>
                  <td className="texto-menor">{l.lkey || "—"}</td>
                </tr>
              ))}

              {licencasDoCliente.length === 0 && (
                <tr>
                  <td colSpan={5} style={{ textAlign: "center" }}>
                    Nenhuma licença cadastrada para este cliente.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
};

export default AdicionaLicencas;
